import type { HarvestProduct } from "../utils/types";
import { useContext } from "react";
import "./HarvestInventoryBusiness.css";
import { EditProductModalBody } from "../modals/EditProductModalBody";
import { HarvestContext } from "../store/HarvestContext";
import { ModalContext } from "../store/ModalContext";
import MobileInventoryLayout from "./MobileInventoryLayout";
import DesktopInventoryLayout from "./DesktopInventoryLayout";
import { useMediaQuery } from "../hooks/useMediaQuery";

type HarvestInventoryBusinessProps = {
  searchProductList: HarvestProduct[];
  currentTypedSearch: string;
};
const HarvestInventoryBusiness = ({
  searchProductList,
  currentTypedSearch,
}: HarvestInventoryBusinessProps) => {
  const { openModal, closeModal } = useContext(ModalContext);
  const { harvestProducts, deleteHarvestProduct } = useContext(HarvestContext);
  const productsToDisplay =
    currentTypedSearch !== "" ? searchProductList : harvestProducts;
  const isMobileLayout = useMediaQuery(
    "(min-width: 800px) and (max-width: 917px), (max-width: 620px)",
  );

  function onOpenWarningModal(id: string) {
    const product = harvestProducts.find((item) => {
      return item.id === id;
    });
    if (product) {
      openModal({
        title: "WARNING",
        body: `Are you sure you want to delete the product: ${product.name}?`,
        buttons: [
          { text: "No", callback: closeModal },
          {
            text: "Yes, delete",
            loadingText: "Deleting...",
            callback: () => handleDeleteProduct(id),
          },
        ],
      });
    }
  }
  async function handleDeleteProduct(id: string) {
    await deleteHarvestProduct(id);
    closeModal();
  }
  function openEditInventory(_state: boolean, id: string) {
    const product = harvestProducts.find((i) => i.id === id);
    openModal({
      title: (
        <span className="harvest-add-n-edit-title">
          {product?.name ?? "Edit product"}
        </span>
      ),
      showCloseButton: true,
      body: (
        <EditProductModalBody
          idToEdit={id}
          closeModal={closeModal}
          renderDeleteButton={isMobileLayout}
          onDelete={(productId) => {
            deleteHarvestProduct(productId);
          }}
        />
      ),
    });
  }
  const inventory = productsToDisplay.map((item: HarvestProduct) => {
    return isMobileLayout ? (
      <MobileInventoryLayout
        key={item.id}
        item={item}
        onOpenEdit={openEditInventory}
        onOpenWarning={onOpenWarningModal}
      />
    ) : (
      <DesktopInventoryLayout
        key={item.id}
        item={item}
        onOpenEdit={openEditInventory}
        onOpenWarning={onOpenWarningModal}
      />
    );
  });

  return (
    <ul className="harvest-inventory-list">
      {harvestProducts.length > 0 ? inventory : <p>Your inventory is empty.</p>}
    </ul>
  );
};

export default HarvestInventoryBusiness;
